const styles = () => ({
  footer: {
    display: 'flex',
    justifyContent: 'flex-end'
  },
  content: {
    minWidth: '750px'
  },
  thumbnail: {
    padding: '14px',
    background: '#f2f2f2',
    borderRadius: '8px',
    '& > div': {
      display: 'block',
      position: 'relative',
      background: '#ececec',
      border: '1px solid #ececec',
      width: '100%',
      paddingBottom: '133%',
      borderRadius: '8px',
      overflow: 'hidden',
      '& > span': {
        position: 'absolute',
        left: '0',
        top: '0',
        backgroundSize: 'cover',
        width: '100%',
        height: '100%'
      }
    }
  },
  upload: {
    overflow: 'hidden',
    width: '100%'
  },
  uploadBtn: {
    float: 'right',
    marginBottom: '16px'
  },
  works: {
    overflow: 'hidden'
  },
  work: {
    float: 'left',
    width: '25%',
    padding: '10px'
  },
  details: {
    /*padding: '14px',*/
    textAlign: 'center'
  },
  title: {
    margin: 0
  },
  btn: {
    marginTop: '8px',
    width: '100%',
    textAlign: 'center',
    display: 'inline-block'
  }
})

export default styles
